module.exports = __webpack_public_path__ + "img/86.2699e584.svg";